import { render, staticRenderFns } from "./perpusDigitalKatalog.vue?vue&type=template&id=2d6864fe&"
import script from "./perpusDigitalKatalog.vue?vue&type=script&lang=js&"
export * from "./perpusDigitalKatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QBtnGroup,QPagination,QDialog,QFile,QIcon,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QBtnGroup,QPagination,QDialog,QFile,QIcon,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
